<template>
  <page class="paymentConfirmation">
    <h4>{{ $t('paymentConfirmation.bravo') }}</h4>
    <div class="paymentConfirmation__content">
      <div class="paymentConfirmation__content-text">
        <p>{{ $t('paymentConfirmation.firstLine') }} {{$moment().format('DD/MM/YYYY, hh:mm')}}</p>
        <p>{{ $t('paymentConfirmation.secondLine') }}</p>
      </div>
      <div class="paymentConfirmation__content-image">
        <img src="@/assets/images/citelis.jpg" />
      </div>
    </div>
  </page>
</template>

<script>
export default {
  name: 'PaymentConfirmation'
}
</script>

<style lang="scss" scoped>
$c: '.paymentConfirmation';

#{$c} {
  padding: 40px;

  p {
    font-size: 18px;
  }

  &__content {
    @include respond-above(md) {
      display: flex;
      justify-content: space-between;
    }

    &-image {
      text-align: center;
      & img {
        width: 270px;
      }
    }
  }
}
</style>